export default type => ({
    type,
    create: (payload, meta) => ({ type, payload, meta }),
});
